<template>
  <div>
    <b-button
      v-b-toggle.collapse-1
      variant="primary"
      style="width: 100%"
      class="filters-show-btn mb-2"
    >
      {{ $t('pages.public-offers.filters.show-filters') }}
    </b-button>
    <b-collapse
      id="collapse-1"
      :visible="!isMobile"
    >
      <div class="filters-card">
        <p class="mb-0">
          {{ $t('pages.public-offers.filters.order-by.order-by') }}
        </p>
        <b-form-checkbox
          id="checkbox-1"
          v-model="orderByDateStatus"
          size="sm"
          name="checkbox-1"
          class="mb-2"
          disabled
        >
          {{ $t('pages.public-offers.filters.order-by.by-date') }}
        </b-form-checkbox>

        <p class="mb-0">
          {{ $t('pages.public-offers.filters.date.date') }}
        </p>
        <b-form-group>
          <b-form-radio
            v-model="filter.maxOfferAge"
            value=""
          >
            {{ $t('pages.public-offers.filters.date.any-date') }}
          </b-form-radio>
          <b-form-radio
            v-model="filter.maxOfferAge"
            value="1"
          >
            {{ $t('pages.public-offers.filters.date.24-hours') }}
          </b-form-radio>
          <b-form-radio
            v-model="filter.maxOfferAge"
            value="7"
          >
            {{ $t('pages.public-offers.filters.date.7-days') }}
          </b-form-radio>
          <b-form-radio
            v-model="filter.maxOfferAge"
            value="15"
          >
            {{ $t('pages.public-offers.filters.date.15-days') }}
          </b-form-radio>
        </b-form-group>

        <p class="mb-0">
          {{ $t('pages.public-offers.filters.keyword.keyword') }}
        </p>
        <b-container
          fluid
          class="mb-2"
        >
          <b-row class="my-1">
            <b-col
              class="p-0"
            >
              <b-input-group>
                <b-input
                  id="inline-form-input-name"
                  v-model="filter.keyword"
                />
                <b-input-group-append>
                  <b-button
                    block
                    variant="primary"
                    @click.prevent="search()"
                  >
                    {{ $t('pages.public-offers.filters.keyword.ok') }}
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
        </b-container>

        <ExpansionBag class="mb-2">
          <p class="mb-0">
            {{ $t('pages.public-offers.filters.place.place') }}
          </p>
          <div
            v-for="province in provincesList"
            :key="province.value"
          >
            <hr
              v-if="['-', ''].indexOf(province.value) !== -1"
              :key="province.value"
            >
            <b-form-checkbox
              v-else
              :key="province.value"
              v-model="filter.provinces"
              size="sm"
              :value="province.value"
            >
              {{ province.text }}
            </b-form-checkbox>
          </div>
        </ExpansionBag>

        <ExpansionBag class="mb-2">
          <p class="mb-0">
            {{ $t('pages.public-offers.filters.category.category') }}
          </p>
          <b-form-checkbox
            v-for="category in categoriesList"
            :key="category.value"
            v-model="filter.categories"
            size="sm"
            :value="category.value"
            name="checkbox-1"
          >
            {{ category.text }}
          </b-form-checkbox>
        </ExpansionBag>

        <ExpansionBag class="mb-2">
          <p class="mb-0">
            {{ $t('pages.public-offers.filters.min-studies.min-studies') }}
          </p>
          <b-form-checkbox
            v-for="minimumStudy in minimumStudies"
            :key="minimumStudy.value"
            v-model="filter.minStudies"
            size="sm"
            :value="minimumStudy.value"
            name="checkbox-1"
          >
            {{ minimumStudy.text }}
          </b-form-checkbox>
        </ExpansionBag>

        <p class="mb-0">
          {{ $t('pages.public-offers.filters.experience.experience') }}
        </p>
        <div class="mb-2">
          <div class="row">
            <div class="col-3">
              <label>{{ $t('pages.public-offers.filters.experience.min') }}</label>
            </div>
            <div class="col-9">
              <b-form-select
                v-model="filter.expMin"
                size="sm"
                :options="expMinimumOptions"
              />
            </div>
            <div class="col-3">
              <label>{{ $t('pages.public-offers.filters.experience.max') }}</label>
            </div>
            <div class="col-9">
              <b-form-select
                v-model="filter.expMax"
                size="sm"
                :options="expMaximumOptions"
              />
            </div>
          </div>
        </div>

        <p class="mb-0">
          <label>{{ $t('pages.public-offers.filters.salary.salary') }}</label>
        </p>
        <div>
          {{ filter.minSalary }} €
          <b-input
            v-model="filter.minSalary"
            type="range"
            :min="minimumSalarySlider.min"
            :max="minimumSalarySlider.max"
            :step="minimumSalarySlider.step"
          />
          <div class="text-center">
            <b-form-radio-group
              v-model="filter.salaryMode"
              :options="salaryModeOptions"
              size="sm"
              button-variant="primary"
              buttons
              @change="changeSalaryMode"
            />
          </div>
        </div>

        <ExpansionBag class="mb-2 mt-4">
          <p class="mb-0">
            {{ $t('pages.public-offers.filters.contract.contract') }}
          </p>
          <b-form-checkbox
            v-for="contractType in contractTypesList"
            :key="contractType.value"
            v-model="filter.contractTypes"
            size="sm"
            :value="contractType.value"
            name="checkbox-1"
          >
            {{ contractType.text }}
          </b-form-checkbox>
        </ExpansionBag>

        <ExpansionBag class="mb-2">
          <p class="mb-0">
            {{ $t('pages.public-offers.filters.shifts.shifts') }}
          </p>
          <b-form-checkbox
            v-for="contractWorkday in contractWorkdaysList"
            :key="contractWorkday.value"
            v-model="filter.contractWorkdays"
            size="sm"
            :value="contractWorkday.value"
            name="checkbox-1"
          >
            {{ contractWorkday.text }}
          </b-form-checkbox>
        </ExpansionBag>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import {
    provinces,
    categories,
    contractTypes,
    contractWorkdays,
    experience,
    minimumStudies as minimumStudiesFactory,
} from "@/assets/data";
import ExpansionBag from "@/components/Home/filters/ExpansionBag";

// ---------------------------
// Constants
const filterFetchDebounceDuration = 500; // milliseconds

export default {
  components: {
    ExpansionBag,
  },

  data() {
    return {
      orderByDateStatus: true,
      filter: {
        keyword: "",
        maxOfferAge: "",
        provinces: [],
        categories: [],
        contractTypes: [],
        contractWorkdays: [],
        minStudies: [],
        minSalary: 0,
        salaryMode: "monthly",
        expMin: "",
        expMax: "",
      },
      minimumSalarySlider: {
        min: 0,
        max: 60000,
        step: 100,
      },
      debouncer: {
        filterDebouncer: null,
      },
      updateFilters: false,
    }
  },

  computed: {
    expMinimumOptions() {
      let clone = experience();
      clone.shift();
      clone = [
        { value: null, text: '' },
          ...clone,
      ];

      if (!this.filter.expMax) {
        return clone;
      }

      for (let i of clone) {
        i.disabled = true;
      }
      for (let i in clone) {
        clone[i].disabled = false;
        if (clone[i].value === this.filter.expMax) break;
      }

      return clone;
    },
    expMaximumOptions() {
        let clone = experience();
        clone.shift();
        clone = [
            { value: null, text: '' },
            ...clone,
        ];

      for (let i in clone) {
        if (Number(i) === 0) {
          clone[i].disabled = false;
          continue;
        }

        if (clone[i].value === this.filter.expMin || !this.filter.expMin) {
          break;
        }

        clone[i].disabled = true;
      }

      return clone;
    },
    isMobile() {
        return window.innerWidth < 768;
    },
    provincesList() {
      let provincesList = provinces();
      provincesList.shift();
      provincesList = [
        { value: "El extranjero", text: this.$t('generic.abroad', 'Abroad') },
        { value: "Toda España", text: this.$t('generic.all-spain', 'All Spain') },
        { value: "-", text: "-" },
        ...provincesList
      ];
      return provincesList;
    },
    categoriesList() {
      let categoriesList = categories();
      categoriesList.shift();
      return categoriesList;
    },
    contractTypesList() {
      let contractTypesList = contractTypes();
      contractTypesList.shift();
      return contractTypesList;
    },
    contractWorkdaysList() {
      let contractWorkdaysList = contractWorkdays();
      contractWorkdaysList.shift();
      return contractWorkdaysList;
    },
    minimumStudies() {
      return minimumStudiesFactory();
    },
    salaryModeOptions() {
      return [
        { text: this.$t('generic.year', 'year'), value: "yearly" },
        { text: this.$t('generic.month', 'month'), value: "monthly" },
        { text: this.$t('generic.hour', 'hour'), value: "hourly" },
      ];
    },
  },
  watch: {
    filter: {
      handler(newVal) {
        // --------------------------------------
        // If salary mode changes - update salary inputs
        if (this.filter.salaryMode !== newVal.salaryMode) {
          this.changeSalaryMode(newVal.salaryMode);
        }

        // --------------------------------------
        // Imitate debounce (clear previous timeout if set)
        if (this.debouncer.filterDebouncer) {
          clearTimeout(this.debouncer.filterDebouncer);
        }

        // --------------------------------------
        // Extract some parameters before the '...rest' like: 'place, ...rest'
        // If unnecessary for search
        // eslint-disable-next-line no-unused-vars
        let { place, ...rest } = newVal;

        // --------------------------------------
        // Prepare query params for the filter
        let queryParams = { ...rest };

        this.$route.query.place && (queryParams.place = this.$route.query.place);
        this.$route.query.category && (queryParams.category = this.$route.query.category);
        this.$route.query.page && (queryParams.page = this.$route.query.page);

        if (this.updateFilters) {
          this.updateFilters = false;
          this.$router.replace({ query: queryParams });
          return;
        }

        this.debouncer.filterDebouncer = setTimeout(() => {
            queryParams.page = 1;
            this.$router.replace({ query: queryParams });
        }, filterFetchDebounceDuration);
      },
      deep: true,
    }
  },

  mounted() {
    // Initialize filters from route query parameters
    this.$route.query.keyword && (this.filter.keyword = this.$route.query.keyword);
    this.$route.query.maxOfferAge && (this.filter.maxOfferAge = this.$route.query.maxOfferAge);
    this.$route.query.category && (this.filter.category = this.$route.query.category);
    this.$route.query.contractTypes && (this.filter.contractTypes = this.$route.query.contractTypes);
    this.$route.query.contractWorkdays && (this.filter.contractWorkdays = this.$route.query.contractWorkdays);
    this.$route.query.expMin && (this.filter.expMin = this.$route.query.expMin);
    this.$route.query.expMax && (this.filter.expMax = this.$route.query.expMax);
    this.$route.query.minStudies && (this.filter.minStudies = this.$route.query.minStudies);
    this.$route.query.provinces && (this.filter.provinces = this.$route.query.provinces);
    this.$route.query.categories && (this.filter.categories = this.$route.query.categories);

    // -------------------------
    // These query parameters are arrays - but through URL comes as a string when only 1 element is inside
    // Check if length is 1 and put into array before setting filter
    if (typeof(this.$route.query.provinces) === "string") {
      this.filter.provinces = [this.$route.query.provinces];
    }

    if (typeof(this.$route.query.categories) === "string") {
      this.filter.categories = [this.$route.query.categories];
    }

    if (typeof(this.$route.query.contractTypes) === "string") {
      this.filter.contractTypes = [this.$route.query.contractTypes];
    }

    if (typeof(this.$route.query.contractWorkdays) === "string") {
      this.filter.contractWorkdays = [this.$route.query.contractWorkdays];
    }

    if (typeof(this.$route.query.minStudies) === "string") {
      this.filter.minStudies = [this.$route.query.minStudies];
    }

    this.updateFilters = true;
  },

  methods: {
    changeSalaryMode(newMode) {
      switch (newMode) {
        case "yearly":
          this.minimumSalarySlider = {
            min: 0,
            max: 60000,
            step: 100,
          };
          break;
        case "monthly":
          this.minimumSalarySlider = {
            min: 0,
            max: 6000,
            step: 10,
          };
          break;
        case "hourly":
          this.minimumSalarySlider = {
            min: 0,
            max: 60,
            step: 0.1,
          };
          break;
      }

      this.filter.minSalary = Math.min(Math.max(this.minimumSalarySlider.min, this.filter.minSalary), this.minimumSalarySlider.max);
    },
    resetFilters() {
      this.filter.keyword = null;
      this.filter.maxOfferAge = null;
      this.filter.category = null;
      this.filter.contractTypes = null;
      this.filter.contractWorkdays = null;
      this.filter.expMin = null;
      this.filter.expMax = null;
      this.filter.minStudies = null;
      this.filter.provinces = null;
      this.filter.categories = null;
    }
  }
}
</script>

<style lang="scss" scoped>
  .filters-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
  }

  @media screen and (min-width: 992px) {
    .filters-show-btn {
      display: none;
    }
  }

</style>
